import { gql } from "lib/apolloClient";
import { aiFragment } from "./AnnouncementAssistantFragments";
import { attachmentFragment } from "modules/CommonFragments";

export const getAIConversationsQuery = gql`
  query getAnnouncementAiConversation($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        id
        entityType
        metadata
        messages {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...aiMessageItem
            }
          }
        }
        attachments {
          ...attachmentItem
        }
      }
    }
  }
  ${aiFragment.aiMessage}
  ${attachmentFragment.attachment}
`;
